import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconEmail = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
        data-fill-none
      >
        <rect
          width="24"
          height="24"
          rx="4"
          fill="#F7F9FD"
        />
        <path
          d="M19 8.44434V15.5554C19 16.0269 18.8156 16.4791 18.4874 16.8125C18.1592 17.1459 17.7141 17.3332 17.25 17.3332H6.75C6.28587 17.3332 5.84075 17.1459 5.51256 16.8125C5.18437 16.4791 5 16.0269 5 15.5554V8.44434"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 8.44428C19 7.97279 18.8156 7.5206 18.4874 7.1872C18.1592 6.8538 17.7141 6.6665 17.25 6.6665H6.75C6.28587 6.6665 5.84075 6.8538 5.51256 7.1872C5.18437 7.5206 5 7.97279 5 8.44428L11.0725 12.2961C11.3506 12.4727 11.672 12.5664 12 12.5664C12.328 12.5664 12.6494 12.4727 12.9275 12.2961L19 8.44428Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
